import React, { ComponentProps } from 'react';
import { asView } from '../../../ViewFetcher';
import { Download } from '../../Download';
import { IFileItem } from '../../../../types/api/FileItem';
import { ISonURL } from '../../../../types/IUrl';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { ContentParagraph } from '../../ContentParagraph';
import { Dfn } from '../../Dfn/Dfn';

type ExternalContentEditDefaultProps = {
  iframe: ISonURL & { popUpUrl?: string };
  fileLinkItem?: IFileItem;
};

function ExternalContentEditDefault({ iframe, fileLinkItem }: ExternalContentEditDefaultProps) {
  const { t } = useSonTranslation('ExternalContent');

  if (!iframe) {
    return null;
  }

  if (fileLinkItem) {
    return (
      <div className="external-content">
        <Download {...fileLinkItem} />
      </div>
    );
  }

  return (
    <div className="external-content">
      <ContentParagraph>
        <Dfn modifier="bold">{t('externalContentUrl')}</Dfn>: {iframe.url}
      </ContentParagraph>
      {iframe?.popUpUrl && (
        <ContentParagraph>
          <Dfn modifier="bold">{t('externalContentPopUpUrl')}</Dfn>: {iframe.popUpUrl}
        </ContentParagraph>
      )}
    </div>
  );
}

export const ExternalContentEditDefaultView = asView(ExternalContentEditDefault);
export type ExternalContentEditDefaultView = ComponentProps<typeof ExternalContentEditDefaultView>;
